import {MomentJsProvider} from '@src/serviceless-providers/MomentJsProvider';
import {NavigationProvider} from '@src/serviceless-providers/NavigationProvider';
import {ModelConfigsProvider} from '@src/serviceless-providers/ModelConfigsProvider';
import {ControllersProvider} from '@src/serviceless-providers/ControllersProvider';
import {EventsListenersProvider} from '@src/serviceless-providers/EventsListenersProvider';
import {WorkScheduleProvider} from '@src/serviceless-providers/WorkScheduleProvider';
import {LanguageProvider} from '@src/serviceless-providers/LanguageProvider';
import {ThemeProvider} from '@src/serviceless-providers/ThemeProvider';
import {UserWorkdayProvider} from '@src/serviceless-providers/UserWorkdayProvider';

export default [
    MomentJsProvider,
    NavigationProvider,
    ModelConfigsProvider,
    ControllersProvider,
    EventsListenersProvider,
    WorkScheduleProvider,
    LanguageProvider,
    ThemeProvider,
    UserWorkdayProvider,
];
